export const customStyles = `
  .form-group {
    position: relative;
    margin-bottom: 20px;
    width: 100%;
  }
  
  .form-group input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  .form-group input.input-error {
    border-color: #ff6b6b;
  }
  
  .form-error-message {
    color: #ff6b6b;
    font-size: 12px;
    margin-top: 4px;
    position: absolute;
    bottom: -18px;
    left: 0;
  }
  
  .select-container {
    margin-bottom: 20px;
    position: relative;
  }
  
  .select-error .react-select__control {
    border-color: #ff6b6b;
  }
`;
